// extracted by mini-css-extract-plugin
export default {"uploadButton":"upload-button_uploadButton__jlVac","uploadButtonText":"upload-button_uploadButtonText__NtGi9","fileUploadHidden":"upload-button_fileUploadHidden__Y8pqW"};